module.exports = __webpack_public_path__ + "static/media/home-bg-211.615c9110.jpg";